// src/pages/NotFound.jsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const NotFound = () => {
  const location = useLocation();
  const isMaintenance = location.pathname.startsWith('/under-maintenance');

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center bg-gray-50 px-4">
      {isMaintenance ? (
        <>
          <div className="text-6xl mb-4">🛠️</div>
          <h1 className="text-4xl font-bold text-talexo-blue mb-3">Page Under Maintenance</h1>
          <p className="text-lg text-gray-700 mb-6 max-w-md">
            We're working hard to bring this feature to you. Please check back soon.
          </p>
        </>
      ) : (
        <>
          <h1 className="text-5xl font-bold text-talexo-blue mb-4">404</h1>
          <p className="text-lg text-gray-700 mb-6">
            Oops! The page you’re looking for doesn’t exist.
          </p>
        </>
      )}
      <Link
        to="/"
        className="text-talexo-blue hover:underline font-medium"
      >
        Go to Home
      </Link>
    </div>
  );
};

export default NotFound;
